import axios from 'axios';
import { ContactInfo, UpdateContactInfoDto } from '../types/contactInfo';

const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:3030';

// Create axios instance with auth interceptor
const api = axios.create({
  baseURL: API_BASE_URL,
});

// Add auth token to requests
api.interceptors.request.use((config) => {
  const token = localStorage.getItem('token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

export const contactInfoApi = {
  // Get all contact info
  getAll: async (): Promise<ContactInfo[]> => {
    const response = await api.get('/contact-info');
    return response.data;
  },

  // Get main contact info
  getMain: async (): Promise<ContactInfo> => {
    const response = await api.get('/contact-info/main');
    return response.data;
  },

  // Get contact info by ID
  getById: async (id: string): Promise<ContactInfo> => {
    const response = await api.get(`/contact-info/${id}`);
    return response.data;
  },

  // Update main contact info
  updateMain: async (data: UpdateContactInfoDto): Promise<ContactInfo> => {
    const response = await api.patch('/contact-info/main', data);
    return response.data;
  },

  // Update contact info by ID
  update: async (id: string, data: UpdateContactInfoDto): Promise<ContactInfo> => {
    const response = await api.patch(`/contact-info/${id}`, data);
    return response.data;
  },

  // Create new contact info
  create: async (data: Partial<ContactInfo>): Promise<ContactInfo> => {
    const response = await api.post('/contact-info', data);
    return response.data;
  },

  // Delete contact info
  delete: async (id: string): Promise<void> => {
    await api.delete(`/contact-info/${id}`);
  },

  // Initialize main contact info
  initialize: async (): Promise<ContactInfo> => {
    const response = await api.post('/contact-info/initialize');
    return response.data;
  },
};